import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import crashReport from './middleware/crashReport';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { gtmMiddleware } from './features/gtm';

let configureStore;

if (process.env.NODE_ENV === 'production') {
    configureStore = require('./configureStore.prod').default;
} else {
    configureStore = require('./configureStore.dev').default;
}

const sagaMiddleware = createSagaMiddleware();
const extraMiddleware = [gtmMiddleware];

export default (preloadedState) => {
    const store = configureStore(rootReducer, preloadedState, [thunk, sagaMiddleware, ...extraMiddleware, crashReport]);
    sagaMiddleware.run(rootSaga);
    return store;
};
